(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- header: solid past hero, hide on scroll down ---------- */
  var hdr = document.querySelector('.hdr');
  if (hdr) {
    var isIndex = document.body.classList.contains('template-index');
    var last = 0;
    var onScroll = function () {
      var y = window.scrollY;
      if (isIndex) hdr.classList.toggle('is-solid', y > window.innerHeight * 0.86);
      hdr.classList.toggle('is-up', y > last && y > 240 && !document.querySelector('.mnav.open'));
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mobile nav ---------- */
  var burger = document.querySelector('.burger');
  var mnav = document.querySelector('.mnav');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      var open = mnav.classList.toggle('open');
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mnav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mnav.classList.remove('open'); burger.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mnav.classList.contains('open')) burger.click();
    });
  }

  /* ---------- reveal on scroll ---------- */
  var io = null;
  if (!reduce) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -4% 0px' });
  }
  function reveal(root) {
    var scope = root || document;
    var targets = scope.querySelectorAll('.rv, .rv-stagger, .draw');
    if (reduce) { targets.forEach(function (el) { el.classList.add('in'); }); return; }
    scope.querySelectorAll('.rv-stagger').forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (c, i) { c.style.setProperty('--i', i); });
    });
    targets.forEach(function (el) {
      /* A block taller than the viewport may never satisfy an intersection
         threshold, so show it straight away if it is already on screen or
         taller than the window. */
      var r = el.getBoundingClientRect();
      if (r.height > window.innerHeight || (r.top < window.innerHeight && r.bottom > 0)) {
        el.classList.add('in');
        return;
      }
      io.observe(el);
    });
    /* Last-resort safety net: nothing stays invisible. */
    setTimeout(function () {
      targets.forEach(function (el) {
        if (!el.classList.contains('in') && el.getBoundingClientRect().top < window.innerHeight * 2) {
          el.classList.add('in');
        }
      });
    }, 1400);
  }
  window.ssReveal = reveal;
  reveal(document);

  /* ---------- accordions ---------- */
  document.querySelectorAll('.acc__t').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.acc__i');
      var panel = item.querySelector('.acc__p');
      var open = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : 0;
    });
  });

  /* ---------- product: swatches, selects, quantity ---------- */
  var idField = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  var priceEl = document.getElementById('price');

  var swatches = document.querySelectorAll('.swatch');
  if (swatches.length && idField) {
    var cur = document.getElementById('sw-current');
    var main = document.querySelector('.pdp__gallery .media:first-child img');
    swatches.forEach(function (b) {
      b.addEventListener('click', function () {
        swatches.forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-on'); b.setAttribute('aria-checked', 'true');
        idField.value = b.dataset.variant;
        if (priceEl && b.dataset.price) priceEl.textContent = b.dataset.price;
        if (cur) cur.textContent = b.dataset.value;
        if (main && b.dataset.img) { main.style.opacity = 0; setTimeout(function () { main.src = b.dataset.img; main.style.opacity = 1; }, 180); }
      });
    });
  }

  var sels = document.querySelectorAll('[data-opt]');
  var dataEl = document.getElementById('variant-data');
  if (sels.length && dataEl && idField) {
    var variants = JSON.parse(dataEl.textContent);
    var sync = function () {
      var chosen = Array.prototype.map.call(sels, function (s) { return s.value; });
      var v = variants.find(function (x) { return chosen.every(function (c, i) { return x.options[i] === c; }); });
      if (v) {
        idField.value = v.id;
        if (priceEl) priceEl.textContent = (v.price / 100).toLocaleString('en-GB', { style: 'currency', currency: dataEl.dataset.currency || 'GBP' });
      }
    };
    sels.forEach(function (s) { s.addEventListener('change', sync); });
  }

  document.querySelectorAll('.pdp__qty').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(input.value, 10) || 1;
        n = b.dataset.step === '+' ? n + 1 : Math.max(1, n - 1);
        input.value = n;
      });
    });
  });

  /* ---------- gift card amounts ---------- */
  var amts = document.querySelectorAll('.gift__amt');
  if (amts.length) {
    amts.forEach(function (b) {
      b.addEventListener('click', function () {
        amts.forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        var f = document.querySelector('.gift form input[name="id"]');
        if (f && b.dataset.variant) f.value = b.dataset.variant;
      });
    });
  }

  /* ---------- bring a submitted form's confirmation into view ---------- */
  (function () {
    var m = document.querySelector('[data-form-ok]');
    if (!m) return;
    setTimeout(function () {
      var y = m.getBoundingClientRect().top + window.pageYOffset - 140;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      try { m.focus({ preventScroll: true }); } catch (e) {}
    }, 120);
  })();

  /* ---------- measure header for the sticky filter bar ---------- */
  (function () {
    var h = document.querySelector('.hdr');
    if (!h) return;
    var set = function () {
      var v = Math.round(h.getBoundingClientRect().height);
      if (v > 0) document.documentElement.style.setProperty(window.innerWidth <= 760 ? '--hdr-hm' : '--hdr-h', v + 'px');
    };
    set();
    window.addEventListener('resize', set, { passive: true });
    window.addEventListener('load', set);
  })();

  /* ---------- recent works ---------- */
  document.querySelectorAll('[data-projects]').forEach(function (root) {
    var frames = root.querySelectorAll('[data-prj-frame]');
    if (!frames.length) return;
    var caps = root.querySelectorAll('[data-prj-cap]');
    var ths = root.querySelectorAll('[data-prj-go]');
    var counter = root.querySelector('[data-prj-i]');
    var i = 0, total = frames.length;

    function show(next) {
      i = (next + total) % total;
      frames.forEach(function (f, x) { f.classList.toggle('is-on', x === i); });
      caps.forEach(function (c, x) { c.classList.toggle('is-on', x === i); });
      ths.forEach(function (t, x) { t.classList.toggle('is-on', x === i); });
      if (counter) counter.textContent = i + 1;
    }

    var prev = root.querySelector('[data-prj-prev]');
    var next = root.querySelector('[data-prj-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    ths.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.dataset.prjGo, 10)); });
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(i - 1); }
      if (e.key === 'ArrowRight') { show(i + 1); }
    });

    var x0 = null;
    var stage = root.querySelector('.prj__frames');
    if (stage) {
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) { show(dx < 0 ? i + 1 : i - 1); }
        x0 = null;
      }, { passive: true });
    }
    show(0);
  });

  /* ---------- product gallery thumbnails ---------- */
  (function () {
    var gal = document.querySelector('[data-gallery]');
    if (!gal) return;
    var main = gal.querySelector('#gal-main');
    var wrap = gal.querySelector('.gal__main');
    if (!main || !wrap) return;
    gal.querySelectorAll('.gal__t').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-on')) return;
        gal.querySelectorAll('.gal__t').forEach(function (b) {
          b.classList.toggle('is-on', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        var src = btn.dataset.full, alt = btn.dataset.alt || '';
        if (reduce) { main.src = src; main.alt = alt; return; }
        wrap.classList.add('is-swapping');
        var pre = new Image();
        pre.onload = function () {
          main.src = src; main.alt = alt;
          requestAnimationFrame(function () { wrap.classList.remove('is-swapping'); });
        };
        pre.src = src;
      });
    });
  })();

  /* ---------- collection filters + sort ---------- */
  (function () {
    var root = document.getElementById('coll-results');
    if (!root) return;

    var panelOpen = false;

    function bind() {
      var form = root.querySelector('[data-facets]');
      if (!form) return;

      var toggle = form.querySelector('[data-fopen]');
      var panel = form.querySelector('#fpanel');
      if (toggle && panel) {
        if (panelOpen) { panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); }
        toggle.addEventListener('click', function () {
          panelOpen = panel.hidden;
          panel.hidden = !panelOpen;
          toggle.setAttribute('aria-expanded', String(panelOpen));
        });
      }

      form.addEventListener('change', function (e) {
        if (e.target.type === 'number') return;
        submit(form);
      });
      form.addEventListener('input', function (e) {
        if (e.target.type !== 'number') return;
        clearTimeout(form._t);
        form._t = setTimeout(function () { submit(form); }, 700);
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); submit(form); });

      root.querySelectorAll('.fpill, .fclear, .fpag a, .ftags a, .fempty a').forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey) return;
          e.preventDefault();
          go(a.getAttribute('href'), a.classList.contains('fpag') || a.closest('.fpag'));
        });
      });
    }

    function submit(form) {
      var data = new FormData(form);
      var parts = [];
      data.forEach(function (v, k) { if (String(v).length) parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); });
      go(form.getAttribute('action') + (parts.length ? '?' + parts.join('&') : ''), false);
    }

    function go(url, isPage) {
      if (!url) return;
      root.classList.add('is-loading');
      var sid = root.dataset.sid;
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      fetch(url + sep + 'section_id=' + sid, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('coll-results');
          if (!fresh) { window.location.href = url; return; }
          root.innerHTML = fresh.innerHTML;
          root.querySelectorAll('a[href*="section_id="]').forEach(function (a) {
            a.setAttribute('href', a.getAttribute('href')
              .replace(/([?&])section_id=[^&]*/, '$1').replace(/[?&]$/, '').replace(/\?&/, '?'));
          });
          history.pushState({}, '', url);
          root.classList.remove('is-loading');
          bind();
          if (window.ssReveal) window.ssReveal(root);
          var bar = root.querySelector('.fbar');
          if (isPage && bar) {
            var top = bar.getBoundingClientRect().top + window.pageYOffset - 100;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        })
        .catch(function () { window.location.href = url; });
    }

    window.addEventListener('popstate', function () { window.location.reload(); });
    bind();
  })();
})();
